import React, { lazy } from "react";

import { useParams } from "react-router-dom";
import useWindowSize from "__hooks/screensize-hook";
import { getDeviceType } from "__utils/helpers.js";
import { GlobalContextProvider } from "__store/GlobalContext";
import ExitPopUp from "__ui/ExitPopUp/ExitPopUp";

const DefaultHome = lazy(() => import("__src/LandingPages/DefaultHome/DefaultHome"));
const LoginLP = lazy(() => import("../LandingPages/Login/LoginLP"));
const PaymentLP = lazy(() => import("../LandingPages/Payment/PaymentLP"));

const HomeLP = lazy(() => import("__src/LandingPages/HomeLP/HomeLP"));
const VideoLp = lazy(() => import("__src/LandingPages/VideoLP/VideoLP"));
const BackgroundImageWithButtonLp = lazy(
	() => import("__src/LandingPages/BackgroundImageWithButtonLp/BackgroundImageWithButtonLp"),
);
const CustomizeLP = lazy(() => import("__src/LandingPages/CustomizeLP/CustomizeLP"));
const ImageLP = lazy(() => import("__src/LandingPages/ImageLP/ImageLP"));

const VideoWeight = lazy(() => import("__src/LandingPages/VideoWeight/VideoWeight"));

const ClickToSpeedUp = lazy(() => import("__src/LandingPages/ClickToSpeedUp/ClickToSpeedUp"));

const VSChoice = lazy(() => import("__src/LandingPages/VSChoice/VSChoice"));

const Sections = lazy(() => import("__src/LandingPages/Sections/Sections"));

const PromotionalGift = lazy(() => import("__src/LandingPages/PromotionalGift/PromotionalGift"));

//route_name: Component
const components = {
	video_weight: VideoWeight,
	video_lp: VideoLp,
	home_lp: HomeLP,
	base_lp: BackgroundImageWithButtonLp,
	customize_girl: CustomizeLP,
	login_lp: LoginLP,
	payment_lp: PaymentLP,
	image_lp: ImageLP,
	speed_video: ClickToSpeedUp,
	vs_choice: VSChoice,
	sections: Sections,
	promotional_gift: PromotionalGift,
};

const DynamicComponentDelivery = () => {
	const { componentName } = useParams();
	const ComponentForRender = components[componentName];

	const windowSize = useWindowSize();

	return (
		<GlobalContextProvider componentName={componentName}>
			<ExitPopUp />

			{ComponentForRender ? (
				<ComponentForRender deviceType={getDeviceType(windowSize.width, windowSize.height)} />
			) : (
				<DefaultHome />
			)}
		</GlobalContextProvider>
	);
};

export default DynamicComponentDelivery;
